
export const TABBED_ITEM = {
  AWAY_TEAM_ITEM: 'AWAY_TEAM',
  HOME_TEAM_ITEM: 'HOME_TEAM',
};
